import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipePrice } from './pipe.price';
import { DiscountPipe } from './discount.pipe';
import { RemainingDaysPipe } from './remaining-days.pipe';
import { IsUsedConverter } from "./isUsedConverter.pipe";
import { PipeRoundUp } from "./roundUp.pipe";
import { countdownTimerPipe } from "./countdown-timer-pipe";
import { remainingSecondsPipe } from "./remainingSeconds.pipe";
import { RoundUpTo5Pipe } from "./roundUpTo5.pipe";
import {MensualPipe} from "./mensual.pipe";


@NgModule({
  declarations: [RoundUpTo5Pipe, PipePrice, DiscountPipe, RemainingDaysPipe, IsUsedConverter, PipeRoundUp, countdownTimerPipe, remainingSecondsPipe, MensualPipe],
  imports: [
    CommonModule
  ],
  exports: [RoundUpTo5Pipe, PipePrice, DiscountPipe, RemainingDaysPipe, IsUsedConverter, PipeRoundUp, countdownTimerPipe, remainingSecondsPipe, MensualPipe]

})
export class PipesModule { }
